import React from 'react';

const FLAME_TIERS = [
  { min: 0, max: 0, scale: 0, label: '', color: 'transparent' },
  { min: 1, max: 2, scale: 0.7, label: 'Braise', color: '#F97316' },
  { min: 3, max: 4, scale: 0.85, label: 'Flamme', color: '#EF4444' },
  { min: 5, max: 7, scale: 1, label: 'Brasier', color: '#DC2626' },
  { min: 8, max: Infinity, scale: 1.15, label: 'Inferno', color: '#FF0040' },
];

function getTier(streak) {
  return FLAME_TIERS.find(t => streak >= t.min && streak <= t.max) || FLAME_TIERS[0];
}

export function StreakFlame({ streak = 0, size = 'md', showLabel = false }) {
  if (!streak || streak <= 0) return null;

  const tier = getTier(streak);
  const sizeMap = { xs: 16, sm: 20, md: 28, lg: 40, xl: 56 };
  const px = sizeMap[size] || sizeMap.md;
  const scaled = Math.round(px * tier.scale);

  return (
    <span
      className="inline-flex flex-col items-center gap-0.5"
      data-testid="streak-flame"
      data-streak={streak}
    >
      <span className="relative" style={{ width: scaled, height: scaled }}>
        <svg
          viewBox="0 0 24 24"
          width={scaled}
          height={scaled}
          className="streak-flame-svg"
          style={{
            filter: `drop-shadow(0 0 ${Math.min(streak, 10)}px ${tier.color}80)`,
          }}
        >
          <defs>
            <linearGradient id={`flameGrad-${streak}`} x1="0%" y1="100%" x2="0%" y2="0%">
              <stop offset="0%" stopColor="#FF6B00" />
              <stop offset="40%" stopColor={tier.color} />
              <stop offset="100%" stopColor="#FFD700" />
            </linearGradient>
          </defs>
          <path
            d="M12 2C12 2 7 7 7 12C7 14.8 8.6 17.2 11 18.3V20C11 20.6 11.4 21 12 21C12.6 21 13 20.6 13 20V18.3C15.4 17.2 17 14.8 17 12C17 7 12 2 12 2Z"
            fill={`url(#flameGrad-${streak})`}
            className="streak-flame-path"
          />
          {streak >= 5 && (
            <path
              d="M12 6C12 6 9.5 9 9.5 12C9.5 13.9 10.6 15.5 12 16C13.4 15.5 14.5 13.9 14.5 12C14.5 9 12 6 12 6Z"
              fill="#FFD700"
              opacity="0.7"
              className="streak-flame-inner"
            />
          )}
        </svg>
      </span>
      {showLabel && (
        <span className="text-[9px] font-bold uppercase tracking-wider" style={{ color: tier.color }}>
          {tier.label}
        </span>
      )}
      <style>{`
        .streak-flame-svg {
          animation: flameFlicker ${1.5 - Math.min(streak * 0.05, 0.5)}s ease-in-out infinite alternate;
        }
        .streak-flame-path {
          animation: flamePulse ${2 - Math.min(streak * 0.08, 0.8)}s ease-in-out infinite alternate;
          transform-origin: bottom center;
        }
        .streak-flame-inner {
          animation: flameInner 1s ease-in-out infinite alternate;
          transform-origin: bottom center;
        }
        @keyframes flameFlicker {
          0% { transform: scaleY(1) scaleX(1); }
          25% { transform: scaleY(1.04) scaleX(0.97); }
          50% { transform: scaleY(0.97) scaleX(1.02); }
          75% { transform: scaleY(1.03) scaleX(0.98); }
          100% { transform: scaleY(1.06) scaleX(0.96); }
        }
        @keyframes flamePulse {
          0% { opacity: 0.85; }
          100% { opacity: 1; }
        }
        @keyframes flameInner {
          0% { transform: scaleY(0.92); opacity: 0.5; }
          100% { transform: scaleY(1.08); opacity: 0.8; }
        }
      `}</style>
    </span>
  );
}

export default StreakFlame;
